import React from 'react';
import classNames from 'classnames';
import EmptyStateImg from 'assets/images/listing-empty-state.webp';
import { useTranslation } from 'react-i18next';
import { ConditionalLink } from 'components/ConditionalLink';
import ResolveImage from 'components/ResolveImage';
import { getCreateDealRoute } from 'utils';

import './ListingInProtfolioEmptyState.styles.scss';

type ListingInProtfolioEmptyStateProps = {
  className?: string;
  dealRoomId: string;
  isDisabled?: boolean;
};

const ListingInProtfolioEmptyState: React.FC<
  ListingInProtfolioEmptyStateProps
> = (props) => {
  const { className, dealRoomId, isDisabled } = props;

  const classes = classNames('listing-in-protfolio-empty-state', className);

  const listingUrl = getCreateDealRoute(dealRoomId, true, 'market-listing');

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyStateImg}
        asIllustration
        alt="Listing not created yet."
      />
      <p>{t('marketADeal')}</p>

      <ConditionalLink isDisabled={isDisabled} to={listingUrl}>
        {t('draftListing')}
      </ConditionalLink>
    </div>
  );
};

export default ListingInProtfolioEmptyState;
